import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_item_list
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackViewItemListItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackViewItemListParameters
    extends TrackEventListParameters<"item_list_id" | "item_list_name", null, TrackViewItemListItem> {}

const trackViewItemList = (parameters: TrackViewItemListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "view_item_list", ...parameters }, options);
};

export default trackViewItemList;
